import { default as _91_46_46_46catchAll_936FA629IU4uMeta } from "/app/pages/[...catchAll].vue?macro=true";
import { default as indexnxoTsLxaQGMeta } from "/app/pages/access-management/applications/[application_id]/api-keys/index.vue?macro=true";
import { default as index350K19YQwiMeta } from "/app/pages/access-management/applications/[application_id]/index.vue?macro=true";
import { default as indexOeZz2JWlMEMeta } from "/app/pages/access-management/applications/index.vue?macro=true";
import { default as indexMbz9x5CbHbMeta } from "/app/pages/access-management/roles/[role_id]/index.vue?macro=true";
import { default as indexjBeuoBXJgMMeta } from "/app/pages/access-management/roles/index.vue?macro=true";
import { default as indexuMZjITmQckMeta } from "/app/pages/access-management/scopes/[scope_id]/index.vue?macro=true";
import { default as indexXwhF8WbpPmMeta } from "/app/pages/access-management/scopes/index.vue?macro=true";
import { default as index7hsnlHGkXSMeta } from "/app/pages/access-management/users/[user_id]/index.vue?macro=true";
import { default as indexQA6PnWuvzuMeta } from "/app/pages/access-management/users/index.vue?macro=true";
import { default as indexiw1opxMLciMeta } from "/app/pages/ai-accuracy-report/index.vue?macro=true";
import { default as indexEgrvVWLJGUMeta } from "/app/pages/ai-management/[id]/index.vue?macro=true";
import { default as indexzRNvK7ydIJMeta } from "/app/pages/ai-management/index.vue?macro=true";
import { default as indexnxtopcZ1z2Meta } from "/app/pages/conversation-history/index.vue?macro=true";
import { default as indexgnxjRs9LIzMeta } from "/app/pages/conversation/[user_id]/[chat_id]/index.vue?macro=true";
import { default as indexiGI2m8EmNfMeta } from "/app/pages/conversation/[user_id]/index.vue?macro=true";
import { default as indexhRA2a8PBPXMeta } from "/app/pages/conversation/index.vue?macro=true";
import { default as indexhg2nWJrbRRMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as indexopRmkDVCkiMeta } from "/app/pages/history-log/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as indexo3eKQF1OBeMeta } from "/app/pages/knowledge-base/[id]/index.vue?macro=true";
import { default as indexVbN5xmMRB4Meta } from "/app/pages/knowledge-base/index.vue?macro=true";
import { default as indexQr1a1bfvsXMeta } from "/app/pages/knowledge/[id]/index.vue?macro=true";
import { default as indexNu882nngOuMeta } from "/app/pages/knowledge/index.vue?macro=true";
import { default as loginhHM0vSTW5jMeta } from "/app/pages/login.vue?macro=true";
import { default as indexRwdg4wLVEfMeta } from "/app/pages/prompt-library/index.vue?macro=true";
import { default as indexpJD7fWWogNMeta } from "/app/pages/quota/[quota_id]/index.vue?macro=true";
import { default as indexAThPK3xkz3Meta } from "/app/pages/quota/index.vue?macro=true";
import { default as indexGHSxdaQaZSMeta } from "/app/pages/report/token-usage/[user_id]/[id]/index.vue?macro=true";
import { default as indexfei2TvSJv2Meta } from "/app/pages/report/token-usage/[user_id]/index.vue?macro=true";
import { default as indexdOnlJmWPxOMeta } from "/app/pages/report/token-usage/index.vue?macro=true";
import { default as indexTGdL0vGEYkMeta } from "/app/pages/semantic-cache/[id]/index.vue?macro=true";
import { default as indexG0AIuzipSNMeta } from "/app/pages/semantic-cache/index.vue?macro=true";
import { default as indexVwXLQwy7DsMeta } from "/app/pages/semantic-cache/playground/index.vue?macro=true";
import { default as indexn00TLIBUb5Meta } from "/app/pages/workflow/[id]/index.vue?macro=true";
import { default as indexUkDK8jUPa4Meta } from "/app/pages/workflow/index.vue?macro=true";
export default [
  {
    name: "catchAll",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_936FA629IU4uMeta || {},
    component: () => import("/app/pages/[...catchAll].vue")
  },
  {
    name: "access-management-applications-application_id-api-keys",
    path: "/access-management/applications/:application_id()/api-keys",
    meta: indexnxoTsLxaQGMeta || {},
    component: () => import("/app/pages/access-management/applications/[application_id]/api-keys/index.vue")
  },
  {
    name: "access-management-applications-application_id",
    path: "/access-management/applications/:application_id()",
    meta: index350K19YQwiMeta || {},
    component: () => import("/app/pages/access-management/applications/[application_id]/index.vue")
  },
  {
    name: "access-management-applications",
    path: "/access-management/applications",
    meta: indexOeZz2JWlMEMeta || {},
    component: () => import("/app/pages/access-management/applications/index.vue")
  },
  {
    name: "access-management-roles-role_id",
    path: "/access-management/roles/:role_id()",
    meta: indexMbz9x5CbHbMeta || {},
    component: () => import("/app/pages/access-management/roles/[role_id]/index.vue")
  },
  {
    name: "access-management-roles",
    path: "/access-management/roles",
    meta: indexjBeuoBXJgMMeta || {},
    component: () => import("/app/pages/access-management/roles/index.vue")
  },
  {
    name: "access-management-scopes-scope_id",
    path: "/access-management/scopes/:scope_id()",
    meta: indexuMZjITmQckMeta || {},
    component: () => import("/app/pages/access-management/scopes/[scope_id]/index.vue")
  },
  {
    name: "access-management-scopes",
    path: "/access-management/scopes",
    meta: indexXwhF8WbpPmMeta || {},
    component: () => import("/app/pages/access-management/scopes/index.vue")
  },
  {
    name: "access-management-users-user_id",
    path: "/access-management/users/:user_id()",
    meta: index7hsnlHGkXSMeta || {},
    component: () => import("/app/pages/access-management/users/[user_id]/index.vue")
  },
  {
    name: "access-management-users",
    path: "/access-management/users",
    meta: indexQA6PnWuvzuMeta || {},
    component: () => import("/app/pages/access-management/users/index.vue")
  },
  {
    name: "ai-accuracy-report",
    path: "/ai-accuracy-report",
    meta: indexiw1opxMLciMeta || {},
    component: () => import("/app/pages/ai-accuracy-report/index.vue")
  },
  {
    name: "ai-management-id",
    path: "/ai-management/:id()",
    meta: indexEgrvVWLJGUMeta || {},
    component: () => import("/app/pages/ai-management/[id]/index.vue")
  },
  {
    name: "ai-management",
    path: "/ai-management",
    meta: indexzRNvK7ydIJMeta || {},
    component: () => import("/app/pages/ai-management/index.vue")
  },
  {
    name: "conversation-history",
    path: "/conversation-history",
    meta: indexnxtopcZ1z2Meta || {},
    component: () => import("/app/pages/conversation-history/index.vue")
  },
  {
    name: "conversation-user_id-chat_id",
    path: "/conversation/:user_id()/:chat_id()",
    meta: indexgnxjRs9LIzMeta || {},
    component: () => import("/app/pages/conversation/[user_id]/[chat_id]/index.vue")
  },
  {
    name: "conversation-user_id",
    path: "/conversation/:user_id()",
    meta: indexiGI2m8EmNfMeta || {},
    component: () => import("/app/pages/conversation/[user_id]/index.vue")
  },
  {
    name: "conversation",
    path: "/conversation",
    meta: indexhRA2a8PBPXMeta || {},
    component: () => import("/app/pages/conversation/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexhg2nWJrbRRMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "history-log",
    path: "/history-log",
    meta: indexopRmkDVCkiMeta || {},
    component: () => import("/app/pages/history-log/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "knowledge-base-id",
    path: "/knowledge-base/:id()",
    meta: indexo3eKQF1OBeMeta || {},
    component: () => import("/app/pages/knowledge-base/[id]/index.vue")
  },
  {
    name: "knowledge-base",
    path: "/knowledge-base",
    meta: indexVbN5xmMRB4Meta || {},
    component: () => import("/app/pages/knowledge-base/index.vue")
  },
  {
    name: "knowledge-id",
    path: "/knowledge/:id()",
    meta: indexQr1a1bfvsXMeta || {},
    component: () => import("/app/pages/knowledge/[id]/index.vue")
  },
  {
    name: "knowledge",
    path: "/knowledge",
    meta: indexNu882nngOuMeta || {},
    component: () => import("/app/pages/knowledge/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginhHM0vSTW5jMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "prompt-library",
    path: "/prompt-library",
    meta: indexRwdg4wLVEfMeta || {},
    component: () => import("/app/pages/prompt-library/index.vue")
  },
  {
    name: "quota-quota_id",
    path: "/quota/:quota_id()",
    meta: indexpJD7fWWogNMeta || {},
    component: () => import("/app/pages/quota/[quota_id]/index.vue")
  },
  {
    name: "quota",
    path: "/quota",
    meta: indexAThPK3xkz3Meta || {},
    component: () => import("/app/pages/quota/index.vue")
  },
  {
    name: "report-token-usage-user_id-id",
    path: "/report/token-usage/:user_id()/:id()",
    meta: indexGHSxdaQaZSMeta || {},
    component: () => import("/app/pages/report/token-usage/[user_id]/[id]/index.vue")
  },
  {
    name: "report-token-usage-user_id",
    path: "/report/token-usage/:user_id()",
    meta: indexfei2TvSJv2Meta || {},
    component: () => import("/app/pages/report/token-usage/[user_id]/index.vue")
  },
  {
    name: "report-token-usage",
    path: "/report/token-usage",
    meta: indexdOnlJmWPxOMeta || {},
    component: () => import("/app/pages/report/token-usage/index.vue")
  },
  {
    name: "semantic-cache-id",
    path: "/semantic-cache/:id()",
    meta: indexTGdL0vGEYkMeta || {},
    component: () => import("/app/pages/semantic-cache/[id]/index.vue")
  },
  {
    name: "semantic-cache",
    path: "/semantic-cache",
    meta: indexG0AIuzipSNMeta || {},
    component: () => import("/app/pages/semantic-cache/index.vue")
  },
  {
    name: "semantic-cache-playground",
    path: "/semantic-cache/playground",
    meta: indexVwXLQwy7DsMeta || {},
    component: () => import("/app/pages/semantic-cache/playground/index.vue")
  },
  {
    name: "workflow-id",
    path: "/workflow/:id()",
    meta: indexn00TLIBUb5Meta || {},
    component: () => import("/app/pages/workflow/[id]/index.vue")
  },
  {
    name: "workflow",
    path: "/workflow",
    meta: indexUkDK8jUPa4Meta || {},
    component: () => import("/app/pages/workflow/index.vue")
  }
]